module.exports = __webpack_public_path__ + "static/media/down.2ded0df9.svg";